<div class="register-entrance-combined mat-body">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
      [driver]="transport.name" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div class="grid">

        <div class="options-list" style="grid-column: 1; grid-row: 1;">
          <div class="form-box">
            <h3>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.supplementaryequipment.title"></sc-dictionary-label>
            </h3>
            <div class="se-grid">

              @if (yardPropertiesService.isShowNoHandoutEnabled()) {
                <div class="form-checkbox" style="grid-column: 1 / span 2; grid-row: 1;"
                  >
                  <mat-checkbox [(ngModel)]="seTransport.noSupplementaryEquipmentHandout"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="isNoSupplementaryEquipmentHandoutDisabled() || isFormReadonly()">
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.label.nosupplementaryequipmenthandout"></sc-dictionary-label>
                  </mat-checkbox>
                </div>
              }

              @for (se of seTransport.supplementaryEquipments; track se; let i = $index) {
                <div class="center" style="grid-column: 1;" [ngStyle]="{'grid-row': i + getRowOffset() }">
                  <mat-checkbox [(ngModel)]="se.selected" [ngModelOptions]="{standalone: true}"
                    [disabled]="isNoSupplementaryEquipmentHandoutSelected() || isFormReadonly()">
                    {{ se.name }}
                  </mat-checkbox>
                </div>
                @if (se.availableIdentifiers?.length > 0) {
                  <sc-content-spacer></sc-content-spacer>
                  <mat-form-field class="checkbox-value" appearance="fill">
                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc-common.equipment.entity.equipment.identifier"></sc-dictionary-label></mat-label>
                      <mat-select name="identity" formControlName="identifier" [disabled]="se.selected === false || isFormReadonly()" required="true">
                        @for (identity of se.availableIdentifiers; track identity) {
                          <mat-option [value]="identity">{{identity}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                }

              </div>
            </div>
          </div>

          @if (isWeighingActive()) {
            <form #weighForm="ngForm" class="weigh-input-form" style="grid-column: 2; grid-row: 1;"
              >
              <div class="form-box">
                <h3>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.weighing.title"></sc-dictionary-label>
                </h3>
                <div class="flex-direction-row row-flex">
                  <mat-form-field class="flex-grow-1" appearance="fill">
                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.weight"></sc-dictionary-label>
                    </mat-label>
                    <input name="value" matInput [(ngModel)]="transport.weight" #ctrlValue="ngModel" type="number" min="0"
                      [readonly]="isFormReadonly()"
                      [required]="yardPropertiesService.getLeaveMinLength() > 0"
                      appPositiveInteger>
                      @if (showValuePositiveIntegerError(ctrlValue)) {
                        <mat-error>
                          <sc-dictionary-label dictionaryKey="tmc.weigh-transport-dialog.error.value-no-integer"></sc-dictionary-label>
                        </mat-error>
                      }
                    </mat-form-field>
                    @if (yardPropertiesService.isWeighingEnabled()) {
                      <sc-button mat-icon-button class="weighingButton" (click)="readWeight()" [hidden]="isAutoWeighingVisible()" dictionaryKey="tmc.visit.overview.action.weighTransport"
                        >
                        <sc-icon iconClass="fa-balance-scale"></sc-icon>
                      </sc-button>
                    }
                    <mat-form-field class="margin-left" appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
                      </mat-label>
                      <mat-select name="type" [(ngModel)]="transport.weighingType" #ctrlType="ngModel"
                        [required]="isWeighingTypeRequired()" [value]="transport.weighingType" [disabled]=isFormReadonly()>
                        @for (o of typeOptions; track o) {
                          <mat-option value="{{o}}">
                            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.weighingType.{{o}}"></sc-dictionary-label>
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </form>
            }

            <div class="form-box" style="grid-column: 1 / span 2; grid-row: 2;">
              <h3>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.checks.title"></sc-dictionary-label>
              </h3>
              <div class="checks-list">
                @if (checksExist(transport)) {
                  <ul>
                    @for (check of transport.checks; track check) {
                      <li class="check">
                        <div class="icon">
                  <i class="fa-light" [ngClass]="{
                      'fa-check color-ok': isOk(check),
                      'fa-exclamation-triangle color-warn': isWarning(check),
                      'fa-exclamation-circle color-error': isFailed(check),
                      'fa-info': isInfo(check)
                    }"></i>
                        </div>
                        <div class="message">
                          <sc-dictionary-label [dictionaryKey]="check.nameDictionaryKey"></sc-dictionary-label>
                          @if (descriptionExists(check)) {
                            -
                            <sc-dictionary-label [dictionaryKey]="check.descriptionDictionaryKey"></sc-dictionary-label>
                          }
                        </div>
                      </li>
                    }
                  </ul>
                }
                @if (!checksExist(transport)) {
                  <span>
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.checks.nochecks"></sc-dictionary-label>
                  </span>
                }
              </div>
            </div>
          </div>
        </div>


        <div class="messages">
          <app-service-response [responseMessages]="responseMessages"></app-service-response>
        </div>
        <sc-actionbar>
          <sc-content-spacer grow></sc-content-spacer>
          <button mat-stroked-button class="cancel-button" (click)="cancel()">
            <sc-dictionary-label dictionaryKey="tmc-yard.common.action.cancel"></sc-dictionary-label>
          </button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-stroked-button (click)="decline()" [disabled]="isDeclineDisabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.action.decline"></sc-dictionary-label>
          </button>
          <sc-content-spacer></sc-content-spacer>
          <button mat-flat-button (click)="accept()" class="confirm-button" [disabled]="isAcceptDisabled()">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.register-entrance-combined.action.accept"></sc-dictionary-label>
          </button>
        </sc-actionbar>
      </div>
    </div>
